import { render } from "./UserCardPlaceholder.vue?vue&type=template&id=51c57cdd&scoped=true"
import script from "./UserCardPlaceholder.vue?vue&type=script&lang=js"
export * from "./UserCardPlaceholder.vue?vue&type=script&lang=js"

import "./UserCardPlaceholder.vue?vue&type=style&index=0&id=51c57cdd&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c57cdd"]])

export default __exports__